import React, { Component } from 'react'
import classNames from 'classnames'
import ReactModal from 'react-modal'

import './index.scss'

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.80)',
    overflowY: 'overlay',
    zIndex: 999,
  },
  content: {
    top: '80px',
    left: '15%',
    right: '15%',
    bottom: 'auto',
    padding: 0,
    border: 'none',
    marginBottom: '20px',
  },
}

class Modal extends Component {
  render() {
    const { children, styleModal, className, selector = '.ThemeProvider' } = this.props
    const wrapperClass = classNames(['modal-wrapper', { [className]: !!className }])

    return (
      <ReactModal
        {...this.props}
        appElement={document.body}
        parentSelector={() => document.querySelector(selector)}
        overlayRef={node => (this.overlay = node)}
        onAfterOpen={() => this.overlay.scrollTo(0, 0)}
        style={!styleModal ? customStyles : styleModal}
      >
        <div className={wrapperClass}>{children}</div>
      </ReactModal>
    )
  }
}

Modal.propTypes = {}

Modal.defaultProps = {}

Modal.displayName = 'Modal'

export default Modal
